"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var currentDate = function (delay) {
    var deviceDate = new Date().getTime();
    if (!delay) {
        return deviceDate;
    }
    return new Date(deviceDate + delay).getTime();
};
exports.default = currentDate;
//# sourceMappingURL=currentDate.js.map